// import { useState, useEffect } from "react";
// import { FaStarOfLife } from "react-icons/fa6";

// const FormFields = ({
//   fields,
//   formData,
//   handleInputChange,
//   onSubmit,
//   onClear,
//   isEditing,
// }) => {
//   const [errors, setErrors] = useState({});
//   const [previewUrl, setPreviewUrl] = useState(null);

//   useEffect(() => {
//     // If already editing and has image URL, show it initially
//     if (formData.image && typeof formData.image === "string") {
//       setPreviewUrl(formData.image);
//     } else {
//       setPreviewUrl(null);
//     }
//   }, [formData.image]);

//   const validateFields = () => {
//     const newErrors = {};
//     fields.forEach((field) => {
//       const value = formData[field.name]?.toString().trim() || "";
//       if (field.required && !value && field.type !== "file") {
//         newErrors[field.name] =
//           field.errorMessage || `${field.label} is required!`;
//       }
//       if (value && field.pattern && !field.pattern.test(value)) {
//         newErrors[field.name] =
//           field.errorMessage || `Invalid ${field.label} format`;
//       }
//       if (field.type === "number" && value) {
//         if (field.min && Number(value) < field.min) {
//           newErrors[field.name] =
//             field.errorMessage || `Minimum value is ${field.min}`;
//         }
//         if (field.max && Number(value) > field.max) {
//           newErrors[field.name] =
//             field.errorMessage || `Maximum value is ${field.max}`;
//         }
//       }
//     });
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleInputChangeWithValidation = (e) => {
//     handleInputChange(e);

//     // If it's file input, create preview
//     if (e.target.type === "file" && e.target.files.length > 0) {
//       const file = e.target.files[0];
//       setPreviewUrl(URL.createObjectURL(file));
//     }

//     setErrors((prev) => {
//       const newErrors = { ...prev };
//       delete newErrors[e.target.name];
//       return newErrors;
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (validateFields()) onSubmit(e);
//   };

//   return (
//     <form onSubmit={handleSubmit} className="space-y-4">
//       {fields?.map((field) => (
//         <div key={field.name} className="mb-4">
//           <label className="block text-sm font-medium text-gray-7 mb-1 flex items-center">
//             {field.label}
//             {field.required && (
//               <span className="text-red-500 ml-1">
//                 <FaStarOfLife className="w-2 h-2" />
//               </span>
//             )}
//           </label>

//           {field.type === "file" ? (
//             <>
//               <input
//                 id={`fileInput-${field.name}`}
//                 type="file"
//                 name={field.name}
//                 accept="image/*"
//                 onChange={handleInputChangeWithValidation}
//                 className={`w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-primary focus:border-primary outline-none ${
//                   errors[field.name] ? "border-red-500" : "border-gray-300"
//                 }`}
//               />
//               {previewUrl && (
//                 <div className="mt-2">
//                   <img
//                     src={previewUrl}
//                     alt="Preview"
//                     className="w-32 h-28 object-cover rounded-md border"
//                   />
//                 </div>
//               )}
//             </>
//           ) : field.type === "select" ? (
//             <select
//               name={field.name}
//               value={formData[field.name] || ""}
//               onChange={handleInputChangeWithValidation}
//               className={`border rounded-md w-full p-2 focus:ring-2 focus:ring-primary focus:border-primary outline-none ${
//                 errors[field.name] ? "border-red-500" : "border-gray-300"
//               }`}
//               disabled={field.disabled}
//             >
//               <option value="">Select {field.label}</option>
//               {field.options?.map((option) => (
//                 <option key={option.value} value={option.value}>
//                   {option.label}
//                 </option>
//               ))}
//             </select>
//           ) : (
//             <input
//               type={field.type}
//               name={field.name}
//               value={formData[field.name] || ""}
//               onChange={handleInputChangeWithValidation}
//               placeholder={field.placeholder}
//               step={field.step || "any"}
//               className={`w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-primary focus:border-primary outline-none ${
//                 errors[field.name] ? "border-red-500" : "border-gray-300"
//               }`}
//               disabled={field.disabled}
//               min={field.min}
//               max={field.max}
//             />
//           )}

//           {errors[field.name] && (
//             <p className="text-red-500 text-xs mt-1">{errors[field.name]}</p>
//           )}
//         </div>
//       ))}

//       <div className="flex justify-end gap-2">
//         <button
//           type="button"
//           onClick={onClear}
//           className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300 transition"
//         >
//           Clear
//         </button>
//         <button
//           type="submit"
//           className="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary-dark transition"
//         >
//           {isEditing ? "Update" : "Submit"}
//         </button>
//       </div>
//     </form>
//   );
// };

// export default FormFields;

import { useState, useEffect } from "react";
import { FaStarOfLife } from "react-icons/fa6";
import { IoMdClose } from "react-icons/io";
import { FaPaperPlane } from "react-icons/fa";
import CRMSelect from "../CustomSelect/CRMSelect.jsx";

const FormFields = ({
  fields,
  formData,
  handleInputChange,
  onSubmit,
  onClear,
  isEditing,
}) => {
  const [errors, setErrors] = useState({});
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    if (formData.image) {
      if (typeof formData.image === "string") {
        // Editing: already has image URL
        setPreviewUrl(formData.image);
      } else if (formData.image instanceof File) {
        // Adding: convert File to object URL
        const fileUrl = URL.createObjectURL(formData.image);
        setPreviewUrl(fileUrl);
      }
    } else {
      setPreviewUrl(null);
    }
  }, [formData.image]);

  const validateFields = () => {
    const newErrors = {};
    fields.forEach((field) => {
      const value = formData[field.name]?.toString().trim() || "";
      if (field.required && !value && field.type !== "file") {
        newErrors[field.name] =
          field.errorMessage || `${field.label} is required!`;
      }
      if (value && field.pattern && !field.pattern.test(value)) {
        newErrors[field.name] =
          field.errorMessage || `Invalid ${field.label} format`;
      }
      if (field.type === "number" && value) {
        if (field.min && Number(value) < field.min) {
          newErrors[field.name] =
            field.errorMessage || `Minimum value is ${field.min}`;
        }
        if (field.max && Number(value) > field.max) {
          newErrors[field.name] =
            field.errorMessage || `Maximum value is ${field.max}`;
        }
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChangeWithValidation = (e) => {
    handleInputChange(e);
    if (e.target.type === "file" && e.target.files.length > 0) {
      const file = e.target.files[0];
      setPreviewUrl(URL.createObjectURL(file));
    }
    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[e.target.name];
      return newErrors;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateFields()) onSubmit(e);
  };

  return (
    <form onSubmit={handleSubmit}>
      {fields?.map((field) => (
        <div key={field.name} className="mb-6">
          <label className="block mb-2  text-sm font-medium text-gray-800 tracking-wide">
            {field.label}
            {field.required && (
              <FaStarOfLife className="inline text-red-500 ml-1 w-2 h-2" />
            )}
          </label>

          {field.type === "file" ? (
            <>
              <label
                htmlFor={`fileInput-${field.name}`}
                className={`w-full flex flex-col items-center justify-center px-4 py-6 border-2 border-dashed rounded-md cursor-pointer transition text-gray-500 bg-white hover:border-primary hover:bg-gray-50 ${errors[field.name] ? "border-red-500" : "border-gray-300"
                  }`}
              >
                <span className="text-sm mb-1">
                  Click to upload or drag an image
                </span>

                {previewUrl && (
                  <div className="mt-2 w-20 h-20 rounded-md items-start overflow-hidden border shadow">
                    <img
                      src={previewUrl}
                      alt="Preview"
                      className="w-full h-full object-cover"
                    />
                  </div>
                )}

                <input
                  id={`fileInput-${field.name}`}
                  type="file"
                  name={field.name}
                  accept="image/*"
                  onChange={handleInputChangeWithValidation}
                  className="hidden"
                />
              </label>
            </>
          ) : field.type === "select" ? (
            <CRMSelect
              name={field.name}
              value={
                field.options.find(
                  (opt) => opt.value === formData[field.name]
                ) || null
              }
              onChange={(selected) =>
                handleInputChangeWithValidation({
                  target: { name: field.name, value: selected?.value || "" },
                })
              }
              options={field.options}
              isDisabled={field.disabled}
              placeholder={`Select ${field.label}`}
              className="react-select-container"
              classNamePrefix="react-select"
              menuPortalTarget={document.body}
              error={errors[field.name]}
            />
          ) : (
            <input
              type={field.type}
              name={field.name}
              value={formData[field.name] || ""}
              onChange={handleInputChangeWithValidation}
              placeholder={field.placeholder || `Enter ${field.label}`}
              step={field.step || "any"}
              className={`w-full px-4 py-2 bg-white border rounded-md focus:outline-none focus:ring-2 focus:ring-primary ${errors[field.name] ? "border-red-500" : "border-gray-300"
                }`}
              disabled={field.disabled}
              min={field.min}
              max={field.max}
            />
          )}

          {errors[field.name] && (
            <p className="text-red-500 text-xs mt-1">{errors[field.name]}</p>
          )}
        </div>
      ))}

      <div className="sticky bottom-0 bg-white flex justify-end gap-4 pt-4 border-t border-gray-200 z-50">
        <button
          type="button"
          onClick={onClear}
          className="flex items-center gap-2 px-5 py-2 rounded-lg border border-primary text-primary hover:bg-primary/10 transition"
        >
          <IoMdClose />
          Clear
        </button>

        <button
          type="submit"
          className="flex items-center gap-2 px-6 py-2 rounded-lg bg-primary text-white hover:bg-primary-dark transition"
        >
          <FaPaperPlane />
          {isEditing ? "Update" : "Submit"}
        </button>
      </div>
    </form>
  );
};

export default FormFields;
